import LoggerUtil from '../../../helpers/LoggerUtil';

export function extractSearchSchema(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (!payload || typeof payload !== 'object') {
    return [];
  }
  const candidates = [
    payload.config,
    payload.data?.config,
    payload.data?.data?.config,
    payload.data?.config?.fields,
    payload.data?.data?.config?.fields,
    payload.config?.fields,
    payload.data?.fields,
    payload.fields,
    payload.data?.catalog,
    payload.catalog,
    payload.data?.schema,
    payload.schema,
    payload.data?.config?.columns,
    payload.data?.data?.config?.columns,
    payload.data?.columns,
    payload.columns,
    payload.data,
    payload.data?.data,
  ];
  return candidates.find(Array.isArray) ?? [];
}

const searchSchemaRequests = new Map();

/**
 * Fetches and caches a list search schema once per storeName.
 * Safe to call from page prefetch and FormSearchAdvanced concurrently.
 */
export async function fetchAndCacheSearchSchema({
  store,
  storeName,
  schemaApiUrl,
  get,
  schema,
}) {
  if (
    (Array.isArray(schema) && schema.length > 0) ||
    !schemaApiUrl ||
    !storeName ||
    !get
  ) {
    return store?.domain?.list?.getSearchSchema?.(storeName) ?? null;
  }

  const cached = store.domain.list.getSearchSchema(storeName);
  if (Array.isArray(cached) && cached.length > 0) {
    return cached;
  }

  const pendingRequest = searchSchemaRequests.get(storeName);
  if (pendingRequest) {
    await pendingRequest;
    return store.domain.list.getSearchSchema(storeName);
  }

  const request = (async () => {
    const response = await get(schemaApiUrl);
    if (!response.ok) {
      LoggerUtil.log('Search Schema API Error', response.error);
      return;
    }

    const nextSchema = extractSearchSchema(response.data);
    // Only cache real schemas — empty extract would lock out future fetches.
    if (Array.isArray(nextSchema) && nextSchema.length > 0) {
      store.domain.list.setSearchSchema(storeName, nextSchema);
      return;
    }

    LoggerUtil.log('Search Schema API Error', {
      message: 'Could not extract fields from search config response',
      payload: response.data,
    });
  })();

  searchSchemaRequests.set(storeName, request);
  try {
    await request;
  } catch (error) {
    LoggerUtil.log('Search Schema API Error', error);
  } finally {
    searchSchemaRequests.delete(storeName);
  }

  return store.domain.list.getSearchSchema(storeName);
}
